import styled, { keyframes } from 'styled-components';

// Medidas do anel — únicas neste componente, por isso vivem aqui em vez de
// virarem prop configurável (evita complexidade sem uso real).
export const SIZE = 14;
const STROKE_WIDTH = 2;
export const RADIUS = (SIZE - STROKE_WIDTH) / 2;
export const CIRCUMFERENCE = 2 * Math.PI * RADIUS;

export const Svg = styled.svg`
  margin-right: 8px;
  vertical-align: middle;
  /* Começa no topo do círculo em vez do padrão (3 horas) do SVG. */
  transform: rotate(-90deg);
`;

export const Track = styled.circle`
  fill: none;
  stroke: ${({ theme }) => theme.colors.semantic.border.default};
  stroke-width: ${STROKE_WIDTH}px;
`;

// Um giro completo do traço a cada 30s, em loop — a mesma cadência do poll
// de status (useWorkstationStatusPolling). O CSS reinicia o ciclo sozinho a
// cada iteração, sem precisar de um timer em JS.
const countdown = keyframes`
  from {
    stroke-dashoffset: 0;
  }
  to {
    stroke-dashoffset: ${CIRCUMFERENCE};
  }
`;

export const Progress = styled.circle`
  fill: none;
  stroke: ${({ theme }) => theme.colors.semantic.text.secondary};
  stroke-width: ${STROKE_WIDTH}px;
  stroke-linecap: round;
  stroke-dasharray: ${CIRCUMFERENCE};
  animation: ${countdown} 30s linear infinite;
  animation-play-state: ${({ paused }) => (paused ? 'paused' : 'running')};
`;
